import React, {useState} from 'react';
import ImagePreview from '../../../ImagePreview';
import {InteractionsPreviewItem} from '../../InteractionsMenuItems';
import edit from '../../../../assets/edit.svg';
import {PDFPreview} from '../../../FilePreview';

const EditPDF = ({
                   fileID,
                   content,
                   updateFile,
                   updateFileMetadata,
                   getFileList,
                   editFormValues,
                   setClickOutsideAllowed,
                   closeDropdown,
                   itemProps,
                   shumaId
                 }) => {
  const [loading, setLoading] = useState(false);
  const handleOpen = async () => {
    closeDropdown();
    if (!Boolean(content)) {
      setLoading(true);
      await updateFile();
    }
    setClickOutsideAllowed(false);
    setLoading(false);
  };
  const handleApprove = (image, payload) => {
    const {freeText, freeID} = payload;
    updateFileMetadata({
      shumaId,
      fileID,
      freeText,
      freeID,
    })
      .then(() => getFileList({shumaId}))
      .then(() => setClickOutsideAllowed(true))
      .finally(closeDropdown);
  };
  const handleReject = () => setClickOutsideAllowed(true);

  return (
    <ImagePreview
      Button={InteractionsPreviewItem({
        label: 'עריכת פרטי קובץ',
        icon: edit,
        onClick: handleOpen,
        ...itemProps[1]
      })}
      formInitialValues={editFormValues}
      onConfirm={handleApprove}
      onReject={handleReject}
      loading={loading}
      pdf={<PDFPreview url={content} editMode={false}/>}
      formFields={'freeTextAndFloors'}
    />
  );
};

export default EditPDF;